import React from 'react';
import Header from '../JobPage/Header';
import Footer from '../JobPage/Footer';
import { CategoryTabs } from './CategoryTab';
import { JobSeekerSection } from './JobSeekerSection';
import { useLocation } from 'react-router-dom';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';

export function OpenTrend() {
  const location = useLocation();
  const { activeTab } = window.state || {};
  
  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col">
      <Header />
      <CategoryTabs activeTab={activeTab} />
      <Container size="default" className="flex-1 py-10">
        <Stack spacing="xl" className="mt-20">
          <section className="text-left ml-[90px] mt-2.5">
            <img 
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/6cebb5579116d2e5357a84493f58959aee1cd32b0714ba300cf640dad3c40bde"
              alt="Main content" 
              className="w-full max-w-[1000px] rounded-2xl mb-10" 
            />
            <Text size="lg" className="text-muted-foreground max-w-[800px] leading-relaxed">
              Lorem ipsum dolor sit amet consectetur. Sed platea elementum in morbi quam sed. 
              Odio at nulla dolor purus aliquam nec turpis a. Fringilla tellus egestas vitae 
              vestibulum mollis commodo. Viverra mattis amet urna lacus quis ultrices duis et sit.
              Lorem ipsum dolor sit amet consectetur. Sed platea elementum in morbi quam sed. 
              Odio at nulla dolor purus aliquam nec turpis a. Fringilla tellus egestas vitae 
              vestibulum mollis commodo. Viverra mattis amet urna lacus quis ultrices duis et sit. 
            </Text>
          </section>
        </Stack>
      </Container>
      <JobSeekerSection />
      <Footer />
    </div>
  );
}
